export default __webpack_public_path__ + "static/media/15-Pandora.bc2420e0.png";